import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const LoveList = forwardRef<SVGSVGElement, SvgIconProps>(
  function LoveList(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m17,8.5c-0.82874,0 -1.5,-0.67219 -1.5,-1.5c0,-0.82874 0.67126,-1.5 1.5,-1.5l2,0c0.82874,0 1.5,0.67126 1.5,1.5c0,0.82781 -0.67126,1.5 -1.5,1.5l-2,0zm2,2c0.82874,0 1.5,0.67126 1.5,1.5c0,0.82874 -0.67126,1.5 -1.5,1.5l-3,0c-0.82874,0 -1.5,-0.67126 -1.5,-1.5c0,-0.82874 0.67126,-1.5 1.5,-1.5l3,0zm0,5c0.82874,0 1.5,0.67219 1.5,1.5c0,0.82874 -0.67126,1.5 -1.5,1.5l-14,0c-0.82874,0 -1.5,-0.67126 -1.5,-1.5c0,-0.82781 0.67126,-1.5 1.5,-1.5l14,0zm-14.25005,-5.41358c-0.87145,-0.78178 -1.24995,-1.63895 -1.24995,-2.40603c0,-1.30825 0.95387,-2.18039 2.4011,-2.18039c1.34835,0 1.80973,0.57179 2.5987,1.39858c0.78942,-0.82714 1.24955,-1.39858 2.5983,-1.39858c1.44764,0 2.4019,0.87215 2.4019,2.18039c0,0.76714 -0.3785,1.62432 -1.24955,2.40603l-3.75065,3.41358l-3.74985,-3.41358z" />
      </SvgIcon>
    )
  },
)

export default LoveList
